import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#005F8E"),
  backgroundColor: "#005F8E",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#005F8E",
  },
  "&:active": {
    backgroundColor: "#005F8E",
  },
  "&:disabled": { color:"white",
    backgroundColor: "#005F8E",
  }
}));

const CustomButton = ({ label, style, onClick, disabled }) => {
  const textStyle = {
    textTransform: "capitalize",
    fontFamily: "Poppins",
    borderRadius: "10px",
  };
  return (
    <ColorButton
      variant="contained"
      sx={{ ...textStyle, ...style }}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </ColorButton>
  );
};

export default CustomButton;
